import React, { useEffect, useState } from "react";
import styles from "../styles/Styles";
import CustomizeText from "./CustomizeText";
import { View, Text, SafeAreaView, ScrollView } from "react-native";

const ContactCard = ({ contact }) => {
  return (
    <View style={{ flex: 1 }}>
        <SafeAreaView style={styles.safeAreaContainer}>
            <ScrollView contentContainerStyle={styles.scrollViewContainer}>
                <View style={styles.contactInfoCard}>
                    <CustomizeText style={styles.listText}>Name: {contact.name}</CustomizeText>
                    <CustomizeText style={styles.listText}>Phone No.: {contact.number}</CustomizeText>
                    <CustomizeText style={styles.listText}>Note: {contact.rela}</CustomizeText>
                </View>
            </ScrollView>
        </SafeAreaView>
    </View>
    
  );
};

export default ContactCard;
